import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sortButton", "saveButton", "cancelButton", "sortableList", "sortableItem", "dragIcon", "dragHeader", "actionsContent"]

  connect() {
    this.sortMode = false
    this.draggedItem = null
  }

  toggleSortMode() {
    this.sortMode = true
    this.sortButtonTarget.classList.add("hidden")
    this.saveButtonTarget.classList.remove("hidden")
    this.cancelButtonTarget.classList.remove("hidden")

    // Show drag header icon
    const headerIcon = this.dragHeaderTarget.querySelector("div")
    if (headerIcon) headerIcon.classList.remove("hidden")

    this.dragIconTargets.forEach(icon => {
      icon.classList.remove("hidden")
    })

    this.actionsContentTargets.forEach(content => {
      content.classList.add("invisible")
    })

    this.enableDragAndDrop()
  }

  cancelSort() {
    this.sortMode = false
    this.sortButtonTarget.classList.remove("hidden")
    this.saveButtonTarget.classList.add("hidden")
    this.cancelButtonTarget.classList.add("hidden")

    // Hide drag header icon
    const headerIcon = this.dragHeaderTarget.querySelector("div")
    if (headerIcon) headerIcon.classList.add("hidden")

    this.dragIconTargets.forEach(icon => {
      icon.classList.add("hidden")
    })

    this.actionsContentTargets.forEach(content => {
      content.classList.remove("invisible")
    })

    this.disableDragAndDrop()

    // Reload page to restore original order
    window.location.reload()
  }

  async saveOrder() {
    const items = this.sortableItemTargets
    const ids = items.map(item => item.dataset.id)
    const url = this.sortableListTarget.dataset.updateUrl

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ category_ids: ids })
      })

      if (response.ok) {
        this.sortMode = false
        this.sortButtonTarget.classList.remove("hidden")
        this.saveButtonTarget.classList.add("hidden")
        this.cancelButtonTarget.classList.add("hidden")

        // Hide drag header icon
        const headerIcon = this.dragHeaderTarget.querySelector("div")
        if (headerIcon) headerIcon.classList.add("hidden")

        this.dragIconTargets.forEach(icon => {
          icon.classList.add("hidden")
        })

        this.actionsContentTargets.forEach(content => {
          content.classList.remove("invisible")
        })

        this.disableDragAndDrop()
      } else {
        alert("순서 저장에 실패했습니다.")
      }
    } catch (error) {
      console.error("Error saving order:", error)
      alert("순서 저장에 실패했습니다.")
    }
  }

  enableDragAndDrop() {
    this.sortableItemTargets.forEach(item => {
      item.draggable = true
      item.addEventListener("dragstart", this.handleDragStart.bind(this))
      item.addEventListener("dragover", this.handleDragOver.bind(this))
      item.addEventListener("drop", this.handleDrop.bind(this))
      item.addEventListener("dragend", this.handleDragEnd.bind(this))
    })
  }

  disableDragAndDrop() {
    this.sortableItemTargets.forEach(item => {
      item.draggable = false
      item.removeEventListener("dragstart", this.handleDragStart.bind(this))
      item.removeEventListener("dragover", this.handleDragOver.bind(this))
      item.removeEventListener("drop", this.handleDrop.bind(this))
      item.removeEventListener("dragend", this.handleDragEnd.bind(this))
    })
  }

  handleDragStart(e) {
    this.draggedItem = e.target.closest("tr")
    this.draggedItem.classList.add("opacity-50", "bg-blue-50")
    e.dataTransfer.effectAllowed = "move"
  }

  handleDragOver(e) {
    e.preventDefault()
    e.dataTransfer.dropEffect = "move"

    const targetRow = e.target.closest("tr")
    if (targetRow && targetRow !== this.draggedItem && targetRow.dataset.categorySortTarget === "sortableItem") {
      const rect = targetRow.getBoundingClientRect()
      const midpoint = rect.top + rect.height / 2

      if (e.clientY < midpoint) {
        targetRow.parentNode.insertBefore(this.draggedItem, targetRow)
      } else {
        targetRow.parentNode.insertBefore(this.draggedItem, targetRow.nextSibling)
      }
    }
  }

  handleDrop(e) {
    e.preventDefault()
  }

  handleDragEnd(e) {
    if (this.draggedItem) {
      this.draggedItem.classList.remove("opacity-50", "bg-blue-50")
      this.draggedItem = null
    }
  }
}
